import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field } from 'react-final-form';
import { Alert, Button, Spin, message } from 'antd';
import { withAsyncActions } from 'react-async-client';
import Translate from 'react-translate-component';
import qs from 'qs';
import * as yup from 'yup';

import withAutoFocusForm from 'components/hocs/withAutoFocusForm';
import { postLinkRegistration, getLoginInfo } from 'actions/asyncActions';
import GuestInput from 'components/common/form/GuestInput';
import ErrorHTML from 'components/common/form/ErrorHTML';
import GuestFooter from 'components/layout/guest/GuestFooter';
import { main } from 'constants/routes';
import withFormWrapper from 'components/hocs/withFormWrapper';
import CustomIcon from 'components/common/CustomIcon';

const validationSchema = yup.object().shape({
    password: yup.string()
        .checkPasswordSecurity()
        .range(6, 15, 'passwordLength')
        .required(),
    passwordRepeat: yup.string()
        .oneOf([yup.ref('password'), null], 'passwordsMustMatch')
        .checkPasswordSecurity()
        .range(6, 15, 'passwordLength')
        .required()
});

const stateToProps = (state, { location }) => ({
    token: qs.parse(location.search, { ignoreQueryPrefix: true }).authKey
});

@withAutoFocusForm
@connect(stateToProps)
@withAsyncActions({
    formAction: postLinkRegistration
        .withSuccessHandler(({ history }) => {
            history.replace(main.path);
            message.success(<Translate content="guest.OfficeWasCreated" />, 3);
        }
    ),
    getLoginInfo: getLoginInfo
        .withPayload(({ token }) => ({ token }))
        .withOptions({ dispatchOnMount: true })
})
@withFormWrapper({
    mapPropsToValues: ({ token, getLoginInfo }) => ({
        token,
        login: getLoginInfo.data.login
    }),
    validationSchema
})
export default class LinkRegistration extends Component {
    renderForm() {
        const { handleSubmit, getLoginInfo: { data } } = this.props;

        return (
            <div className="m-t-10">
                <Translate content="user.welcome" with={{ user: data.user }} component="div" className="m-b-15" />
                <Field
                    name="login"
                    component={GuestInput}
                    type="text"
                    disabled={true}
                    placeholder="guest.email"
                    prefix={<CustomIcon type="user-man" />}
                />
                <Field
                    name="password"
                    component={GuestInput}
                    type="password"
                    placeholder="placeholders.createPassword"
                    prefix={<CustomIcon type="unlock" />}
                />
                <Field
                    name="passwordRepeat"
                    component={GuestInput}
                    type="password"
                    placeholder="placeholders.createPasswordRepeat"
                    prefix={<CustomIcon type="unlock" />}
                />
                <Button htmlType="submit"
                        type="primary"
                        size="large"
                        className="login-form-button"
                        onClick={handleSubmit}>
                    <Translate content="user.register" />
                </Button>
            </div>
        )
    }

    renderError() {
        return (
            <Alert message={<Translate content="guest.invalidAuthToken" />} type="error" />
        )
    }

    render() {
        const { formAction: { meta }, token, getLoginInfo: { meta: loginMeta } }  = this.props;

        return (
            <div>
                <ErrorHTML meta={meta} />
                <Spin spinning={meta.pending || loginMeta.pending}>
                    { token && !loginMeta.error ? this.renderForm() : this.renderError() }
                    <GuestFooter />
                </Spin>
            </div>
        );
    }
}
